<template>
  <div class="pageContent">
    <!--顶部一条-->
    <mu-appbar>
      <!--返回上一层-->
        <mu-icon value="keyboard_arrow_left" color="white" style="margin-bottom: -0.05rem" slot="left" v-on:click="goback" />
      <span class="topT">激活</span>
      <!--<mu-icon value="keyboard_arrow_left" color="white" slot="left" v-on:click="goback" />-->
      <!--<mu-icon value="keyboard_arrow_left" color="#27ba69" slot="right" />-->
    </mu-appbar>

    <br />
      
      
    <div class="bigpages">
      <div class="cardinfo">
        <div class="h phone">姓名：{{UserName}}</div>
        <div class="h phone">卡号：{{Card_no}}</div>
        <div class="h phone">卡类：{{cardkind}}</div>
      </div>
    <div class="phone h" style="" >手机号：<input class="phonetext pw" type="text" v-model="cardPhone" ></div>
    <!-- <input class="Obtain" type="button" value="获取验证码" v-on="Obtain"> -->
    <div class="phone h" style="padding-bottom:0.1rem;" > 验证码：<input class="phonetext" type="text" v-model="activationCode"><span class="vertical">|</span><div class="Obtain" @click="Obtain">获取</div></div>
   <div class="h activationc" @click="ActivateCellPhone">激活</div>
    </div>
  <mu-toast v-if="toast" v-bind:message="TellUser" @close="hideToast" id="alertline" />

<!-- <mu-toast v-if="toast" v-bind:message="this.TellUser" @close="hideToast" id="alertline" />
   <pop :display='popDisplayU' @closeHandler='closePop' @okHandler='closeYESU' title='提示' :msg='popMsg' :onlyOk='popOnlyOk' /> -->
  </div>
</template>



<script>
import { mapMutations, mapGetters } from 'vuex'
import api from '../../../api'

export default {
  data() {
    return {
    UserName:'',
      Card_no:'',
      cardkind:'',
      cardPhone:'',
      activationCode:'',
       toast: false,
      TellUser: '',
    }
  },
  //进入时运作
  activated() {   
     this.cardPhone=this.$route.query.cardphone;
     this.cardkind=this.$route.query.cardkind;
     this.Card_no=this.$route.query.cardno;
     this.UserName=this.$route.query.cardname;
  },
  // 数据获取
  computed: {
    ...mapGetters(['g_UserInfo', 'g_loginInfo'])
    
  },
  methods: {
    ...mapMutations(['setG_UserInfo', 'setG_loginInfo']),
    //手机短信验证码
    getSmsYZM() {
      if (this.UserPhone == '') {
        this.TellUser = '请输入手机号'
        this.showToast()
      } else {
        this.haveYZM = true
        this.WaitTime = this.Time + '秒'
        this.timer()
      }
      var params = new this.URLSearchParam()
      params.append('phoneNo', this.UserPhone)
      params.append('captcha', this.validate)

      this.$http.post(api.getYdSMSLoginCode(), params.toParam()).then(res => {
        window.captchaInsD.refresh() //清理验证码
        if (res.Result == true) {
          this.TellUser = res.Data
          this.showToast()
        } else {
          // 失败
          this.TellUser = res.Message
          this.showToast()
          this.FJM1 = ''
          this.Time = 5
        }
      })
    },
    //  快捷登录
    QuickLogin() {
      if (this.UserPhone == '') {
        this.TellUser = '请输入手机号'
        this.showToast()
      } else if (this.Verification2 == '') {
        this.password = '请输入附加码'
        this.showToast()
      } else if (this.YZM == '') {
        this.TellUser = '请输入动态密码'
        this.showToast()
      } else {
        var params = new this.URLSearchParam()
        params.append('phoneNo', this.UserPhone)
        params.append('captcha', this.FJM1)
        params.append('validateCode', this.YZM)

        //  快捷登录
        this.$http.post(api.GOQuickLogin(), params.toParam()).then(res => {
          if (res.Result == true) {
            var result = res.Data
            // 保存登录信息
            this.SaveUserInfo(result)
            var loginInfo = this.g_loginInfo
            loginInfo.Card_no = res.Data.Card_no
            this.setG_loginInfo(loginInfo)
            //this.goback()
          } else {
            //登陆失败
            this.TellUser = res.Message
            this.showToast()

            if (this.TellUser == '需要强制改密') {
              this.TellUser = '您的账号存在安全隐患，请您立即重置密码。'
              setTimeout(() => {
                this.$router.push({ path: '/user/ForgotPass' })
              }, 2200)
            }
          }
        })
      }
    },
    closePop() {
      this.popDisplayU = false;
    },
     closeYESU() {
      this.popDisplayU = false;
       console.log(this.cardphone);
       this.$router.push({ path: "/user/activation?cardkind="+this.g_UserInfo.Card_Kind_Diplay+"&cardno="+this.g_UserInfo.Card_no+"&cardphone="+this.g_UserInfo.Phone+"&cardname="+this.g_UserInfo.Name})
    //  this.$router.push({ path: "/user/activation",params:{cardkind:this.cardkind,cardno:this.cardno,cardphone:this.cardphone,cardname:this.cardname}});
    },
   goback() {
    //  if (this.g_UserInfo.IsOtherUser) {
    //     this.$router.push({ path: '/user/Login' });
    //     return
    //   }
      this.$router.push({ path: '/user/UserCenter' })
      // javascript: history.go(-1);
    },
    //获取验证码
    Obtain(){
      if(this.cardPhone==""){
         this.TellUser = '手机号不能为空'
        this.showToast()
       }
       var params = new this.URLSearchParam()
        params.append('phoneNo', this.cardPhone)

      this.$http.post(api.SMSCode(), params.toParam()).then(res => {
        if(res.Result==true){
          console.log(res);
          this.TellUser = res.Data;
          this.showToast()
        }else{
        this.TellUser = res.Message;
        this.showToast()
        }

      })
    },
    //
     ActivateCellPhone(){
       this.cardPhone=this.cardPhone.trim();
       this.activationCode=this.activationCode.trim();
       this.Card_no=this.Card_no.trim();
       if(this.cardPhone==""){
         this.TellUser = '手机号不能为空'
        this.showToast()
       }
            if(this.activationCode==""){
         this.TellUser = '手机号不能为空'
        this.showToast()
       }

       var params = new this.URLSearchParam()
        params.append('cardno', this.Card_no)
        params.append('phone', this.cardPhone)
        params.append('activationCode', this.activationCode)       
      this.$http.post(api.ActivateCellPhone(), params.toParam()).then(res => {
        if(res.Result==true){
          this.g_UserInfo.IsActivated=true;
          console.log(this.g_UserInfo.IsActivated)
          console.log(this.g_UserInfo)
          this.TellUser = res.Data;
       this.showToast()
          if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => {        
        this.goback();
      }, 2500)
        }else{
           this.TellUser = res.Message;
        this.showToast()
        }

      })
    },
    //弹框
      showToast() {
        this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => {
        this.toast = false
      }, 2500)
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
  


 
 
  }
}
</script>


<style lang="less" >
@import '../../../assets/theme.less'; // 顶部标签变换
.bigpages{
 width: 90%;
 margin-left:5%;
}
.phone{
  border-bottom: 1px silver solid;
}
.pw{
  width: 300px;
}
.phonetext{
  width: 50%;
  border-width: 0;
 outline:none;
}
.Obtain{
  width: 26%;
  height: 30px;
  font-size: 15px;
  text-align: center;
  line-height: 30px;
  display: inline-block;
  color: #27ba69;
  margin-left: 10px;
}
.h{
  margin-top: 20px;
  padding-bottom:0.1rem;
}
.vertical{
  font-size: 100;
  color: #EDEDED;
}
.activationc{
  
color: #ffffff;
  width: 100%;
  height: 10%;
  background-color: #27ba69;
  text-align: center;
  line-height: 235%;
 


}
</style>






// WEBPACK FOOTER //
// Activation.vue?f8d80aec